module.exports = __webpack_public_path__ + "static/img/13073C_2_3_R_20190910_LC.bca44cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/13073C_2_3_R_20190910_LC.png
// module id = n7YM
// module chunks = 0